import { Context } from 'common/contexts'
import { GlobalStyles } from 'common/styles'

import { Landing } from 'views'

export const App = () => {
  return (
    <>
      <Context>
        <GlobalStyles />
        <Landing />
      </Context>
    </>
  )
}

export default App
